import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Mot de passe mis à jour !");
      setTimeout(() => navigate("/"), 2500);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Lien invalide ou expiré");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <p className="text-red-600 font-bold">Lien invalide.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-zinc-50">
      <div className="bg-white border-2 border-black shadow-hard-red w-full max-w-md p-8">
        <h1 className="font-display font-black text-3xl mb-2">Nouveau mot de passe</h1>
        <p className="text-zinc-500 text-sm mb-6">Choisissez un nouveau mot de passe pour votre compte Easy Pièces.</p>

        {done ? (
          <p className="text-green-600 font-bold text-center">Mot de passe mis à jour ! Redirection...</p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input
              className="input-base" type="password" placeholder="Nouveau mot de passe"
              value={password} onChange={(e) => setPassword(e.target.value)}
              required minLength={6}
            />
            <input
              className="input-base" type="password" placeholder="Confirmer le mot de passe"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              required minLength={6}
            />
            <button type="submit" className="btn-primary w-full" disabled={loading}>
              {loading ? "..." : "Mettre à jour"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
